<template>
    <div id="addInvoiceItemModal" ref="addInvoiceItemModal" class="modal fade" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body !p-[25px] flex flex-col gap-[30px]">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-[5px]">
                            <div class="w-[8px] h-[8px] rounded-full bg-[#FE5000]"></div>
                            <div class="w-[35px] h-[8px] rounded-[10px] bg-[#FE5000]"></div>
                            <h1 class="m-0 text-[20px] font-lato font-bold text-[#092E87]">{{ isEdit ? 'Edit' :
                                'Add New' }} Invoice</h1>
                        </div>
                        <button @click="hide()"
                            class="w-[34px] h-[34px] flex items-center justify-center rounded-full p-[5px] bg-[#EFEFEF] laptop:bg-[#fff] hover:laptop:bg-[#EFEFEF]">
                            <img src="../../assets/images/dismiss-orange-icon.svg" alt="Dismiss Icon"
                                class="w-[15px] h-[15px] object-contain">
                        </button>
                    </div>
                    <div class="flex flex-col gap-[3px]">
                        <label class="m-0 text-[14px] font-lato font-normal text-[#666666]">Total Amount</label>
                        <div
                            class="relative flex items-center gap-[10px] rounded-[10px] overflow-hidden border-[1px] border-[#efefef]">
                            <h6
                                class="m-0 font-lato text-[20px] w-[40px] h-[40px] flex items-center justify-center text-[#fff] bg-[#092E87]">
                                $</h6>
                            <input v-model="invoiceForm.total" type="number" placeholder="0.00"
                                class="outline-none w-full h-full border-0 font-lato font-normal text-[16px] text-[#999] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none">
                        </div>
                    </div>
                    <div class="pt-[30px] relative rounded-[15px] p-[15px] border border-[#ccc] ">
                        <button @click="addItem"
                            class="absolute -top-[20px] right-[20px] z-[1] group flex items-center gap-[5px] rounded-full p-[5px] pr-[15px] border-[1px] border-[#CCCCCC] bg-gradient-to-r from-[#FFFFFF] to-[#F1F1F1] hover:border-[#FE5000] hover:bg-none hover:from-transparent hover:to-transparent hover:!bg-[#FE5000]">
                            <img src="../../assets/images/plus-orange-circle-icon.svg" alt="Button Icon"
                                class="w-[30px] h-[30px] object-cover group-hover:hidden">
                            <img src="../../assets/images/plus-white-circle-icon.svg" alt="Button Icon"
                                class="w-[30px] h-[30px] object-cover hidden group-hover:block">
                            <span class="font-lato text-[14px] text-[#333] group-hover:text-[#fff]">Add Items</span>
                        </button>
                        <div id="itemList" ref="itemList" v-if="invoiceForm?.items?.length"
                            class="flex flex-col gap-[30px] px-[10px] py-[20px] min-h-[200px] max-h-[200px] overflow-y-auto customScrollbar">
                            <div v-for="(item, index) in invoiceForm.items" :key="index"
                                class="relative p-[15px] rounded-[10px] shadow-[0px_0px_10px_0px_#00000026]">
                                <button @click="removeItem(index)"
                                    class="group absolute -top-[15px] right-[15px] rounded-full w-[30px] h-[30px] flex items-center justify-center border-[1px] border-[#efefef] bg-[#FE5000] laptop:bg-[#fff] laptop:hover:bg-[#FE5000]">
                                    <img src="../../assets/images/delete-on-filled-orange.svg" alt="Delete Icon"
                                        class="w-[16px] h-[16px] object-contain hidden laptop:block group-hover:hidden">
                                    <img src="../../assets/images/delete-on-filled.svg" alt="Delete Icon"
                                        class="laptop:hidden w-[16px] h-[16px] object-contain group-hover:block">
                                </button>
                                <div class="flex flex-col gap-[4px]">
                                    <label class="m-0 text-[14px] font-lato font-normal text-[#666666]">Item
                                        Name</label>
                                    <div
                                        class="relative flex items-center gap-[10px] h-[40px] rounded-[7px] p-[10px] overflow-hidden border-[1px] border-[#efefef]">
                                        <input v-model="item.name" @input="item.error = false" type="text"
                                            placeholder="Enter Item Name"
                                            class="outline-none w-full h-full border-0 font-lato font-normal text-[16px] text-[#666] placeholder:text-[#999]">
                                    </div>
                                    <p v-if="item.error" class="m-0 text-[12px] text-[#EF4444] font-lato">
                                        Please Fill the Field
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div v-else class="flex items-center justify-center min-h-[200px]">
                            <p class="m-0 text-[16px] font-lato font-normal text-[#666666]">No Items Available</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center">
                        <button @click="saveInvoice" :disabled="isSaveDisabled"
                            class="rounded-full px-[30px] py-[8px] font-lato text-[16px] font-normal border-[1px] border-[#092E87] bg-[#092E87] text-[#fff] disabled:!bg-[#fff] disabled:!border-[#ccc] disabled:!text-[#ccc] disabled:!cursor-not-allowed">{{
                                isEdit ? 'Update' :
                                    'Save' }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            modal: null,
            itemError: '',
            invoiceForm: {
                job_type: 'sar',
                job_id: this.$route.params.id,
                source: 'manual',
                total: 0
            },
            isEdit: false,
            source: '',
        };
    },

    computed: {
        ...mapGetters(["invoiceItem", "invoiceItemError", "invoiceItemList", "invoiceList"]),
        isSaveDisabled() {
            return (
                !this.invoiceForm?.total ||
                this.invoiceForm?.items?.length === 0 ||
                this.invoiceForm?.items?.some(item => !item.name?.trim())
            );
        }
    },

    watch: {
        invoiceItemError: function () {
            if (this.invoiceItemError.length <= 0) {
                return
            }
            this.itemError = this.invoiceItemError
            this.$dialog.show({
                text: this.itemError,
                buttonText: "Dismiss",
                onConfirm: () => {
                    this.updateInvoiceItemError()
                },
            });
            this.hide()
        },
        invoiceItemList: function () {
            if (this.source == 'create' || this.source == 'edit') {
                this.invoiceForm['items'] = this.invoiceItemList
                this.modal?.show();
            }
        }
    },

    methods: {
        ...mapActions(["addInvoiceItem", "getInvoiceItem", "updateInvoiceItemError"]),

        show(source, val) {
            delete this.invoiceForm["items"]
            delete this.invoiceForm["invoice_id"]
           // delete this.invoiceForm['total']
            this.isEdit = false
            this.source = source
           

            this.invoiceForm['source'] = source
            if (this.invoiceForm.source == 'edit') {
                this.invoiceForm['invoice_id'] = val.id
                this.invoiceForm['total'] = val.amount
                this.isEdit = true
            }
            else{
                this.invoiceForm['total'] = val.remaining
            }
            this.getInvoiceItem(this.invoiceForm)
            if (!this.modal) {
                this.modal = new Modal(this.$refs.addInvoiceItemModal, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
        },

        hide() {
            this.source = ''
            this.modal?.hide();
        },

        addItem() {
            const emptyIndex = this.invoiceForm.items.findIndex(
                item => !item.name?.trim()
            );

            // Clear previous errors
            this.invoiceForm.items.forEach(item => {
                item.error = false;
            });

            if (emptyIndex !== -1) {
                this.invoiceForm.items[emptyIndex].error = true;
                return;
            }

            this.invoiceForm.items.unshift({
                id: null,
                name: '',
                error: false
            });

            this.$nextTick(() => {
                this.$refs.itemList.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        },

        removeItem(index) {
            this.$dialog.show({
                title: "Delete Item",
                text: 'Are you sure you want to delete this item?',
                onConfirm: () => {
                    this.invoiceForm.items.splice(index, 1);
                },
            });
        },

        async saveInvoice() {
            this.invoiceForm["source"] = 'manual'
            const success = await this.addInvoiceItem(this.invoiceForm);
            if (success) {
                this.hide();
                this.$emit('success');
            }
        }
    }
}
</script>